// extracted by mini-css-extract-plugin
export default {"container":"ZHcEcpuzIfCwhBCYNtwB","icon":"ch6mNPIkKjGgRn3YIRGs","title":"zra5DpOeo_m2hXcgzMYs","content":"Tixpya5qfAWQkL9Cfout","buttons":"Eg4e4hkmx6A7OsUiXtfO"};